import { render, staticRenderFns } from "./TituloFormularioDocumentoPadrao.vue?vue&type=template&id=1b6d509c&"
import script from "./TituloFormularioDocumentoPadrao.vue?vue&type=script&lang=js&"
export * from "./TituloFormularioDocumentoPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports